import React, { Component } from 'react';
// import { Redirect } from 'react-router-dom';
import ApiService from '../services/apiService';
// import AuthService from '../services/authService';
// import config from '../config';
// import moment from 'moment';
import L from '../services/localizationService';
// import StorageService from '../services/storageService';

// import BillingsForecast from './billingsforecast';
// import CostCodeSeriesDialog from './costCodeSeriesDialog';
// import CurrencyInput from './currencyinput';

import { CircularProgress } from '@rmwc/circular-progress';
import { DataTable, DataTableContent, DataTableHead, DataTableRow, DataTableHeadCell, DataTableCell, DataTableBody } from '@rmwc/data-table';
import { Select } from '@rmwc/select';
import { Button } from '@rmwc/button';
import { Icon } from '@rmwc/icon';

class OPNR extends Component {
  constructor(props) {
    super(props)

    this.state = {
      loadingData: true,
      poData: [],
      unpaidPOs: [],
      groupedUnpaid: [],
      totals: null,
      view: 'groupedUnpaid',
      expanded: [],
    }

    this.toggleExpanded = this.toggleExpanded.bind(this);
    this.expandCollapseAll = this.expandCollapseAll.bind(this);
  }

  componentDidMount() {
    if (this.props.project) {
      this.getOPNRData();
    }
  }

  expandCollapseAll(action) {
    if (action === 'expand') {
      this.setState({ expanded: this.state.groupedUnpaid.map(m => m.id) })
    }
    else {
      this.setState({ expanded: [] })
    }
  }

  toggleExpanded(itemId) {
    if (this.state.expanded.includes(itemId)) {
      this.setState({ expanded: this.state.expanded.filter(f => f !== itemId) })
    }
    else {
      this.setState({ expanded: [itemId, ...this.state.expanded] });
    }
  }

  joinCommittedCosts(data, poData, costDetailLookup) {
    const costCodes = [];
    const notFoundItems = [];

    data.forEach(item => {
      const costCodeModulo = parseInt(parseInt(item.CostCode || 0) / 100);
      const costCodeGroupId = (costCodeModulo * 100).toString().padStart(3, '0');

      let costCodeGroup = costCodes.find(f => f.id === costCodeGroupId);
      if (!costCodeGroup) {
        costCodeGroup = { id: costCodeGroupId, name: L.costCodeDescriptions[costCodeModulo], items: [], opnr: 0, poCalcOpnr: 0, extCosts: 0, extendedCost: 0, received: 0 };
        costCodes.push(costCodeGroup);
      }

      const foundItem = poData.find(p => p.PoNum && item.RefNum && p.PoLine && item.RefLineSuf && p.PoNum.trim() === item.RefNum.trim() && p.PoLine.trim() === item.RefLineSuf.trim());
      if (foundItem) {
        costCodeGroup.items.push(foundItem);

        foundItem.CostCode = item.CostCode;

        // Replicate ue_WMS_SLProjCost.DerOPNR formula: (qty_ordered - qty_received) * item_cost
        let rowOpnr = (L.parseFloatWithZero(foundItem.QtyOrdered) - L.parseFloatWithZero(foundItem.QtyReceived)) * L.parseFloatWithZero(foundItem.ItemCost);
        costCodeGroup.poCalcOpnr += rowOpnr;
        costCodeGroup.extCosts += rowOpnr;
        costCodeGroup.extendedCost += L.parseFloatWithZero(foundItem.DerExtPlanCostConvExc);
        costCodeGroup.received += L.parseFloatWithZero(foundItem.DerTotalRcvdCostExc);
      }
      else {
        notFoundItems.push(item);
      }
    })

    console.log('notFoundItems', notFoundItems)

    // Use SyteLine's DerOPNR for group totals instead of manual PO-level calculation
    console.group('OPNR Comparison: Cost Detail (SLProjCosts) vs PO Items (SLPoItems)');
    costCodes.forEach(group => {
      group.opnr = 0;
      group.items = group.items.sort(this.columnSorter);

      // Sum DerOPNR from cost detail report for all cost codes in this series
      Object.keys(costDetailLookup).forEach(costCode => {
        let ccModulo = parseInt(parseInt(costCode || 0) / 100);
        let ccGroupId = (ccModulo * 100).toString().padStart(3, '0');
        if (ccGroupId === group.id) {
          group.opnr += costDetailLookup[costCode];
        }
      });

      let diff = group.opnr - group.poCalcOpnr;
      let match = Math.abs(diff) < 0.01;
      console[match ? 'log' : 'warn'](
        `${group.id} ${group.name || ''}:  CostDetail=$${group.opnr.toFixed(2)}  POItems=$${group.poCalcOpnr.toFixed(2)}  diff=$${diff.toFixed(2)}${match ? '' : ' âš ï¸'}`
      );
    });
    console.groupEnd();

    return costCodes.sort((a, b) => a.id.localeCompare(b.id));
  }

  async getOPNRData() {
    this.setState({ loadingData: true })

    try {
      const poData = await ApiService.getPOItemsForOPNR(this.props.project.ProjNum);
      const committedCosts = await ApiService.getProjectCommittedCosts(this.props.project.ProjNum);
      const costDetailReport = await ApiService.getProjectCostDetailReport(this.props.project.ProjNum);

      // Build lookup of cost code â†’ DerOPNR from SyteLine's authoritative data
      const costDetailLookup = {};
      costDetailReport.forEach(item => {
        let cc = item.CostCode.trim();
        costDetailLookup[cc] = (costDetailLookup[cc] || 0) + L.parseFloatWithZero(item.DerOPNR);
      });

      // Calc core totals
      let totals = {
        allPOs: {
          extCosts: 0,
          extendedCost: 0,
          opnr: 0,
        },
        unpaidPOs: {
          extCosts: 0,
          extendedCost: 0,
          opnr: 0,
        },
      }

      poData.forEach(po => {
        // Replicate ue_WMS_SLProjCost.DerOPNR formula: (qty_ordered - qty_received) * item_cost
        po.opnr = (L.parseFloatWithZero(po.QtyOrdered) - L.parseFloatWithZero(po.QtyReceived)) * L.parseFloatWithZero(po.ItemCost);
        totals.allPOs.opnr += po.opnr;
        totals.allPOs.extCosts += po.opnr;
        totals.allPOs.extendedCost += L.parseFloatWithZero(po.DerExtPlanCostConvExc);
        totals.allPOs.received += L.parseFloatWithZero(po.DerTotalRcvdCostExc);
      })

      // Filter out "paid"
      const unpaidPOs = poData.filter(p => p.opnr > 0);

      unpaidPOs.forEach(po => {
        totals.unpaidPOs.extCosts += L.parseFloatWithZero(po.DerExtPlanCostConvExc) - L.parseFloatWithZero(po.DerTotalRcvdCostExc);
        totals.unpaidPOs.extendedCost += L.parseFloatWithZero(po.DerExtPlanCostConvExc);
        totals.unpaidPOs.received += L.parseFloatWithZero(po.DerTotalRcvdCostExc);
      })

      // Use SyteLine's DerOPNR for the overall unpaid total
      totals.unpaidPOs.opnr = Object.values(costDetailLookup).reduce((sum, v) => sum + v, 0);

      const mappedCosts = this.joinCommittedCosts(committedCosts, unpaidPOs, costDetailLookup);

      if (this.props.onExportDataset) {
        this.props.onExportDataset({ type: 'opnr', data: mappedCosts, project: this.props.project, totals: totals.unpaidPOs});
      }

      this.setState({
        poData: poData,
        unpaidPOs: unpaidPOs,
        groupedUnpaid: mappedCosts,
        totals: totals,
      })
    }
    catch (err) {
      console.error(err);
    }
    finally {
      this.setState({ loadingData: false })
    }
  }

  columnSorter(a, b) {
    let sortVal = 0;
    
    try {
      if (a.CostCode !== undefined && b.CostCode !== undefined) {
        sortVal = a.CostCode.localeCompare(b.CostCode);
      }

      if (sortVal === 0) {
        sortVal = parseInt(a.PoNum) - parseInt(b.PoNum);
      }

      if (sortVal === 0) {
        sortVal = parseInt(a.PoLine) - parseInt(b.PoLine);
      }
    }
    catch (err) {
      console.error('Error sorting: ', a, b, err);
    }

    return sortVal;
  }

  renderDetailsTable(costCodeGroup) {

    if (!this.state.loadingData) {
      if (this.state.poData.length > 0) {
        let tableContent = null;

        const dataSource = (costCodeGroup && costCodeGroup.items) || (this.state.view === 'all' ? this.state.poData : this.state.unpaidPOs);
        const totalsSource = costCodeGroup || (this.state.view === 'all' ? this.state.totals.allPOs : this.state.totals.unpaidPOs);

        const tableStyle = costCodeGroup ? { border: 'none', width: '100%' } : { width: '100%' };
        const cellStyle = costCodeGroup ? { backgroundColor: 'whitesmoke' } : {};

        tableContent = dataSource.map((item, index) => {
          return (
            <DataTableRow key={`po_item_index_${index}`}>
              <DataTableCell style={cellStyle}>{L.trimmedString(item.CostCode)}</DataTableCell>
              <DataTableCell style={cellStyle}>{L.trimmedString(item.PoNum)}</DataTableCell>
              <DataTableCell style={cellStyle}>{L.trimmedString(item.PoLine)}</DataTableCell>
              <DataTableCell style={{ ...cellStyle, width: 250 }}>{L.trimmedString(item.Description)}</DataTableCell>
              <DataTableCell style={{ ...cellStyle, width: 200 }}>{L.trimmedString(item.VenadrName)}</DataTableCell>
              {/* <DataTableCell style={cellStyle}>{L.trimmedString(item.PoVendorPo)}</DataTableCell> */}
              <DataTableCell style={cellStyle}>{L.poStatToDesc(item.PoStat)}</DataTableCell>
              <DataTableCell style={cellStyle}>{L.sytelineDateToMoment(item.PoOrderDate).format('L')}</DataTableCell>
              {/* <DataTableCell style={cellStyle}>{L.trimmedString(item.Item)}</DataTableCell> */}
              <DataTableCell style={cellStyle}>{L.trimmedString(item.DerStatFormatted)}</DataTableCell>

              <DataTableCell style={cellStyle}>{L.toCurrencyString(item.DerExtPlanCostConvExc)}</DataTableCell>
              <DataTableCell style={cellStyle}>{L.toCurrencyString(item.DerTotalRcvdCostExc)}</DataTableCell>

              <DataTableCell style={cellStyle}>{L.toCurrencyString(item.opnr)}</DataTableCell>
              {/* <DataTableCell style={cellStyle}>{L.toCurrencyString(item.ItemCost)}</DataTableCell>
              <DataTableCell style={cellStyle}>{L.toCurrencyString(item.opnr)}</DataTableCell>
              <DataTableCell style={cellStyle}>{L.toCurrencyString(item.DerExtPlanCostConv)}</DataTableCell> */}
            </DataTableRow>)
        });

        return <div style={{ marginTop: '1rem', display: 'flex', justifyContent: 'center' }} className="ctc-timing">
          <DataTable style={tableStyle} className="dashboard-detail-report-table">
            <DataTableContent style={{width: '100%'}}>
              <DataTableHead>
                <DataTableRow>
                  <DataTableHeadCell style={cellStyle}>Cost<br/>Code</DataTableHeadCell>
                  <DataTableHeadCell style={cellStyle}>PO</DataTableHeadCell>
                  <DataTableHeadCell style={cellStyle}>Line</DataTableHeadCell>
                  <DataTableHeadCell style={{ ...cellStyle, width: 250 }}>Description</DataTableHeadCell>
                  <DataTableHeadCell style={{ ...cellStyle, width: 200 }}>Vendor Name</DataTableHeadCell>
                  {/* <DataTableHeadCell style={cellStyle}>Vendor PO</DataTableHeadCell> */}
                  <DataTableHeadCell style={cellStyle}>PO Status</DataTableHeadCell>
                  <DataTableHeadCell style={cellStyle}>Order Date</DataTableHeadCell>
                  {/* <DataTableHeadCell style={cellStyle}>Item</DataTableHeadCell> */}
                  <DataTableHeadCell style={cellStyle}>Line Status</DataTableHeadCell>
                  <DataTableHeadCell style={cellStyle}>Ordered</DataTableHeadCell>
                  <DataTableHeadCell style={cellStyle}>Received</DataTableHeadCell>

                  <DataTableHeadCell style={cellStyle}>OPNR</DataTableHeadCell>
                  {/* <DataTableHeadCell style={cellStyle}>Item Cost</DataTableHeadCell> */}
                  {/* <DataTableHeadCell style={cellStyle}>Ext Costs</DataTableHeadCell>
                  <DataTableHeadCell style={cellStyle}>Extended Costs</DataTableHeadCell> */}
                </DataTableRow>
              </DataTableHead>

              <DataTableBody>

                {tableContent}

                <DataTableRow key={`totals_${dataSource ? dataSource.id : ''}`} style={{ fontWeight: 'bold' }}>
                  <DataTableCell style={cellStyle}>{ !costCodeGroup && 'TOTALS' }</DataTableCell>
                  <DataTableCell style={cellStyle}></DataTableCell>
                  <DataTableCell style={cellStyle}></DataTableCell>
                  <DataTableCell style={cellStyle}></DataTableCell>
                  <DataTableCell style={cellStyle}></DataTableCell>
                  <DataTableCell style={cellStyle}></DataTableCell>
                  <DataTableCell style={cellStyle}></DataTableCell>
                  <DataTableCell style={cellStyle}></DataTableCell>
                  {/* <DataTableCell style={cellStyle}></DataTableCell> */}
                  {/* <DataTableCell style={cellStyle}></DataTableCell> */}
                  <DataTableCell style={cellStyle}>{L.toCurrencyString(totalsSource.extendedCost)}</DataTableCell>
                  <DataTableCell style={cellStyle}>{L.toCurrencyString(totalsSource.received)}</DataTableCell>
                  <DataTableCell style={cellStyle}>{L.toCurrencyString(totalsSource.opnr)}</DataTableCell>
                  {/* <DataTableCell style={cellStyle}></DataTableCell>
                  <DataTableCell style={cellStyle}>{L.toCurrencyString(totalsSource.extCosts)}</DataTableCell>
                  <DataTableCell style={cellStyle}>{L.toCurrencyString(totalsSource.extendedCost)}</DataTableCell> */}
                </DataTableRow>
              </DataTableBody>
            </DataTableContent>
          </DataTable></div>

      }
      else {
        return <div style={{ textAlign: 'center' }}><b>No OPNR for this project</b></div>
      }
        
    }
    return <div style={{ textAlign: 'center' }}>Loading Project Details...<br /><CircularProgress /></div>
  }

  renderGroupedTable() {
    if (!this.state.loadingData) {

      if (this.state.poData.length > 0) {
        const totalsSource = this.state.totals.unpaidPOs;

        const tableContent = this.state.groupedUnpaid.filter(f => f.opnr !== 0).map((item) => {
          let opnrMismatch = Math.abs(item.opnr - item.poCalcOpnr) > 0.01;
          return ([
            <DataTableRow key={`${item.id}_series`}>
              <DataTableCell style={{ width: 8 }}>{item.items.length > 0 && <button onClick={() => this.toggleExpanded(item.id)}>{this.state.expanded.includes(item.id) ? 'â–²' : 'â–¼'}</button>}</DataTableCell>
              <DataTableCell>{item.id} SERIES</DataTableCell>
              <DataTableCell>{item.name}</DataTableCell>

              <DataTableCell>
                {L.toCurrencyString(item.opnr)}
                {opnrMismatch && <Icon icon="warning" style={{color: 'orange', fontSize: '16px', marginLeft: '4px', verticalAlign: 'middle', cursor: 'pointer'}}
                  title={`PO-calculated OPNR: ${L.toCurrencyString(item.poCalcOpnr)} (difference: ${L.toCurrencyString(item.opnr - item.poCalcOpnr)})`} />}
              </DataTableCell>
              {/* <DataTableCell>{L.toCurrencyString(item.extCosts)}</DataTableCell>
              <DataTableCell>{L.toCurrencyString(item.extendedCost)}</DataTableCell> */}
            </DataTableRow>,

            this.state.expanded.includes(item.id) && item.items.length > 0 &&
            <DataTableRow key={`${item.id}_sub_table`}>
              <DataTableCell style={{ padding: 0 }} colSpan={6}>
                {this.renderDetailsTable(item)}
              </DataTableCell>
            </DataTableRow>
          ])
        });

        return <div style={{ marginTop: '1rem' }} className="dashboard content-max-width">
          <DataTable style={{ width: '100%', maxHeight: '80vh' }}>
            <DataTableContent style={{ width: '100%' }}>
              <DataTableHead>
                <DataTableRow>
                  <DataTableHeadCell style={{ width: 8 }}></DataTableHeadCell>
                  <DataTableHeadCell>Cost Code</DataTableHeadCell>
                  <DataTableHeadCell style={{ width: '100%' }}>Description</DataTableHeadCell>
                  <DataTableHeadCell>OPNR</DataTableHeadCell>
                  {/* <DataTableHeadCell>Ext Costs</DataTableHeadCell>
                  <DataTableHeadCell>Extended Costs</DataTableHeadCell> */}
                </DataTableRow>
              </DataTableHead>

              <DataTableBody className="no-hover">

                {tableContent}

                <DataTableRow key="grouped_totals" style={{ fontWeight: 'bold' }}>
                  <DataTableCell className="totals-row">TOTALS</DataTableCell>
                  <DataTableCell className="totals-row"></DataTableCell>
                  <DataTableCell className="totals-row"></DataTableCell>
                  <DataTableCell className="totals-row" >{L.toCurrencyString(totalsSource.opnr)}</DataTableCell>
                  {/* <DataTableCell  className="totals-row">{L.toCurrencyString(totalsSource.extCosts)}</DataTableCell>
                  <DataTableCell  className="totals-row">{L.toCurrencyString(totalsSource.extendedCost)}</DataTableCell> */}
                </DataTableRow>
              </DataTableBody>
            </DataTableContent>
          </DataTable></div>
      }
      else {
        return <div style={{ textAlign: 'center' }}><b>No OPNR for this project</b></div>
      }
    }
    return <div style={{ textAlign: 'center' }}>Loading Project Details...<br /><CircularProgress /></div>
  }

  render() {
    return (
      <div style={{ marginTop: '1.5rem', width: '100%' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between' }} className="dashboard-header content-max-width">
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {this.state.view === 'groupedUnpaid' ? <>
              <Button raised style={{ marginRight: 16 }} onClick={() => this.expandCollapseAll('expand')}>Expand All</Button>
              <Button raised onClick={() => this.expandCollapseAll('collapse')}>Collapse All</Button>
            </>
              :
              <div />
            }
          </div>
          <Select
            label="View" value={this.state.view}
            onChange={(e) => this.setState({ view: e.target.value })}>
            {/* <option value="all">All</option> */}
            <option value="unpaid">Detail</option>
            <option value="groupedUnpaid">Grouped</option>
          </Select>
        </div>

        <div style={{ maxHeight: '80vh' }}>
          {this.state.view !== 'groupedUnpaid' && this.renderDetailsTable()}
          {this.state.view === 'groupedUnpaid' && this.renderGroupedTable()}
        </div>
      </div>
    )
  }
}

export default OPNR;
